import * as XLSX from "xlsx";

const HEADER_ROW = ["Cliente", "Cargado por", "Total cajas"];
const TOTAL_ROW_LABEL = "Total";

export default function exportSoldBoxesByCustomerAndArticleToExcel(articleColumnNames, rows, total) {
    const header = [...HEADER_ROW, ...articleColumnNames];
    const dataRows = rows.map((row) => [row.customer, row.loadedBy, row.totalBoxes, ...row.cells]);
    const totalRow = [TOTAL_ROW_LABEL, "", total.totalBoxes, ...total.cells];
    const worksheet = XLSX.utils.aoa_to_sheet([header, ...dataRows, totalRow]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Cajas por Cliente y Artículo");
    XLSX.writeFile(workbook, "cajas-por-cliente-y-articulo.xlsx");
}
